"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Product_module_1 = tslib_1.__importDefault(require("./modules/Product.module"));
const Authentication_module_1 = tslib_1.__importDefault(require("./modules/Authentication.module"));
const Session_module_1 = tslib_1.__importDefault(require("./modules/Session.module"));
const loadProductReviewModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData), (0, Session_module_1.default)(), (0, Authentication_module_1.default)()],
});
exports.default = loadProductReviewModule;
